import React from "react";

import { Container, Grid } from "@material-ui/core";

import CustomVerticleTab from "../../../../Components/CustomVerticleTab";
import ClientInvoicingDetails from "./ClientInvoicingDetails";
import Expenses from "./Expenses";
import ProgramRateDetails from "./ProgramRateDetails";
import CancellationDetails from "./CancellationDetails";
import ProgrammePrice from "./ProgrammePrice";

function ClientProgrammeNotes() {
  return (
    // <Container>
    <Grid container>
      <Grid xs={12}>
        <CustomVerticleTab
          tabNames={[
            "Client invoicing details",
            "Program price",
            "Program rate details",
            "Expenses",
            "Cancellation details",
          ]}
          tabContent={[
            <ClientInvoicingDetails key={0} />,
            <ProgrammePrice key={1} />,
            <ProgramRateDetails key={2} />,
            <Expenses key={3} />,
            <CancellationDetails key={4} />,
          ]}
        />
      </Grid>
    </Grid>
    // </Container>
  );
}

export default ClientProgrammeNotes;
